export class DepartamentoModel {
    constructor(
        public id_departamento: number,
        public nombre_departamento: string        
    ) { }
}